
import './OffRentInsurance.css';

const OffRentInsurance = ()=>{
    return(
        <>
<section className="offRentInsuranceMain" id="offRentInsuranceMain">
  <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-9">
                <div className="headoffRentInsurance">
                    <h2><span>Off-Rent Insurance</span> to protect assets and remain compliant.</h2>
                    {/* <a className="btn btnWhite" href="#">Start Off-Rent Quote<img src="/img/arrow_spl.svg" alt="icon"/></a> */}
                </div>
            </div>
        </div>
        <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="offRentInsuranceInner">
                            <img width="54" height="54" src="/img/rentshield/protect_1.svg" alt="icon"/>
                            <h3>Protect Your Assets</h3>
                            <p>Purchase only the coverage you need, and let us protect your fleet when it’s not in use. 
                            Keep your tags active without relying on other insurance policies.</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="offRentInsuranceInner">
                            <img width="54" height="54" src="/img/rentshield/protect_2.svg" alt="icon"/>
                            <h3>Ease of Mind</h3>
                            <p>Off-rent coverage exceeds state minimum limits in nearly all 50 states, offering comprehensive coverage for 
                            fleet use during maintenance, refueling, and car washes.</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="offRentInsuranceInner">
                            <img width="54" height="54" src="/img/rentshield/protect_3.svg" alt="icon"/>
                            <h3>Legally Required</h3>
                            <p>Your vehicles must be insured on and off your lot. Off-rent coverage provides primary commercial auto coverage, 
                            essential for vehicles used as income sources.</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="offRentInsuranceInner">
                            <img width="54" height="54" src="/img/rentshield/protect_4.svg" alt="icon"/>
                            <h3>Off-Rent Events</h3>
                            <p>Coverage is activated when your vehicle is idle on your lot, providing continuous coverage as 
                            you prepare it for the next rental—including trips for gas, maintenance, or a car wash.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</section>

<section className="ultimateInsuranceMain">
  <div className="container">
    <div className="row align-items-center">
        <div className="col-lg-6 col-md-6">
            <div className="ultimateInsuranceLeft">
                <small>OFF RENT INSURANCE PROTECTION</small>
                <h2>The <span>ultimate insurance</span> partnership for car rental </h2>
                <div className="ultimateInsuranceBtn">
                    {/* <a className="btn btnWhite" href="#">Start Quote<img src="/img/arrow_spl.svg" alt="rent id"/></a> */}
                    <a className="btn btnTransparent_1" href="/general-question">Talk to Sales<img src="/img/arrow-right-white.svg" alt="Talk to sales"/></a>
                </div>            
            </div>
        </div>
        <div className="col-lg-6 col-md-6">
            <div className="ultimateInsuranceRight">
                <img className="img-fluid" src="/img/rentshield/onRent_diagram.png" alt="rent id"/> 
            </div>
        </div>
    </div>
    {/* <div className="row align-items-center">
        <div className="col-lg-9 col-md-12">
            <div className="ultimateInsuranceBottom">
                <p>At this time, Rentid recognizes American Business Insurance (ABI) as an accredited off-rent insurance provider who meets and exceeds insurance regulations & standards. 
            Maintaining an active off-rent policy is required to opt into RentShield’s on-rent coverage.</p>
            </div>
        </div>
    </div> */}
  </div>
</section>

        </>
    )
}

export default OffRentInsurance;